<template>
    <scope-input :alert="alert" v-model="scopeState" @input="inp" />
</template>

<script>
  import ScopeInput from './ScopeInput'
  import {shiftKeyOnly} from 'ol/events/condition'
  import Draw from 'ol/interaction/Draw'

  import DragBox from 'ol/interaction/DragBox'
  import Wkt from 'ol/format/WKT'

  export default {
    name: 'ScopeManager',
    components: {ScopeInput},
    beforeDestroy () {
      if (this.layer) {
        this.layer.getSource().clear()
      }
      this.$mapService.removeInteraction(this.interaction)
    },
    created () {
      let wkt = new Wkt()
      if (!this.bbox) {
        this.layer = this.$mapService.map.getLayers().getArray().filter(layer => layer.get('kegs_id') === 'drawing_custom_v5')[0];
        this.interaction = new Draw({
          source: this.layer .getSource(),
          type: 'Polygon',
          geometryName: 'geo',
          freehandCondition: shiftKeyOnly
        })
      } else {
        this.interaction = new DragBox()
      }

      let fn = (e) => {
        let extent = this.bbox ? this.interaction.getGeometry().getExtent() : wkt.writeGeometry(e.feature.getGeometry());
        this.$mapService.removeInteraction(this.interaction)
        this.$store.commit('map/hideAllWidgets', false)

        this.emitScope(extent)


        if (!this.emitable) {
          this.$store.commit('map/scopeState', 'custom_after')
        }

        document.removeEventListener('keyup', this.esc)
      }

      this.interaction.on(this.bbox ? 'boxend' : 'drawend', fn);
    },
    props: {
      value: {
        default: null
      },
      emitable: {
        default: false,
        type: Boolean
      },
      bbox: {
        default: true,
        type: Boolean
      },
      alert: {
        default: null,
        type: String
      }
    },
    data () {
      return {
        st: null
      }
    },
    computed: {
      scopeState: {
        get () {
           return this.emitable ? this.st : this.$store.getters['map/scopeState']
        },
        set (val) {
          this.emitable ? (this.st=val) : this.$store.commit('map/scopeState', val)
        }
      }
    },
    methods: {
      emitScope (extent) {
        let ext = null
        if (extent) {
          ext = extent.toLowerCase().indexOf('polygon') > -1 ? extent : extent.join(',')
        }
        if (!this.emitable) {
          this.$store.commit('map/scopeAOI', ext)
        } else {
          this.$emit('input', ext)
        }
      },
      inp (val) {
        if (val === 'custom_before') {
          this.$notify({
            title: 'Info',
            text: 'Click and drag to set bounds for scope',
            type: 'info'
          })
          this.$store.commit('map/hideAllWidgets', true)
          this.$mapService.addInteraction(this.interaction)
          document.addEventListener('keyup', this.esc)
        } else if (val === 'current') {
          let extent = this.$mapService.map.getView().calculateExtent(this.$mapService.map.getSize())
          this.emitScope(extent)
        } else {
          this.emitScope(null)
        }
      },
      esc (e) {
        if (e.keyCode === 27) {
          this.$store.commit('map/hideAllWidgets', false)
           document.removeEventListener('keyup', this.esc)
        }
      }
    }
  }
</script>

<style lang="scss">
  .ol-dragbox {
    background-color: rgba(0,255,0,0.7);
  }
</style>



// WEBPACK FOOTER //
// src/components/map/designotron/ScopeManager.vue